import { useCallback, useEffect, useState } from 'react'

const STORAGE_KEY = 'ludus.sidebar-collapsed'

export function useSidebar() {
  const [isCollapsed, setIsCollapsed] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.localStorage.getItem(STORAGE_KEY) === 'true'
  })

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, String(isCollapsed))
  }, [isCollapsed])

  const toggle = useCallback(() => setIsCollapsed((prev) => !prev), [])
  const collapse = useCallback(() => setIsCollapsed(true), [])
  const expand = useCallback(() => setIsCollapsed(false), [])

  // Mobile off-canvas drawer. Transient (never persisted) — a drawer must always
  // start closed on load, unlike the desktop collapse state above.
  const [mobileOpen, setMobileOpen] = useState(false)
  const openMobile = useCallback(() => setMobileOpen(true), [])
  const closeMobile = useCallback(() => setMobileOpen(false), [])

  return { isCollapsed, toggle, collapse, expand, mobileOpen, openMobile, closeMobile }
}
